import React from 'react';
import PropTypes from 'prop-types';

import Layout from 'components/Layout';
import Meta from 'components/Meta';
import { TrainingDetailContainer } from 'styles/training-detail';
import {
  ThreeColumnRedTiles,
  TrainingDetailHero,
  TwoColumnRedAndBlackTile,
  SummaryAndBio,
  PricingDetails,
  FAQSection,
} from 'components/TrainingDetailSections';
import SectionContact from 'components/SectionContact';
import escapeToHTML from 'utils/escapeToHTML';

import SettingsIcon from 'images/icons/settings.svg';
import WavesIcon from 'images/icons/waves.svg';

const SafeTraining = ({ training, path }) => {
  const isScrumTraining = training.trainingId.startsWith('CSM') || training.trainingId.startsWith('CSPO');
  const isPmpTraining = training.trainingId.startsWith('PMP')

  const threeColumnRedTileData = [
    {
      title: 'Prerequisites',
      description: escapeToHTML(training.prerequisites),
    },
    {
      title: 'Exam Details',
      description: escapeToHTML(training.examDetails),
    },
    {
      title: 'Who benefits?',
      description: escapeToHTML(training.whoWillBenefit),
    },
  ];

  const twoColumRedAndBlackTileData = [
    {
      title: 'Learning Goals',
      description: escapeToHTML(training.learningGoals),
    },
    {
      title: 'Topics Covered',
      description: escapeToHTML(training.topicsCovered),
    },
  ];

  const benefits = {
    title: 'ATC Training - Exclusive Benefits',
    list: [
      'Training Conducted by SAFe Transformation Experts',
      <>
        <b>1 Year Membership</b> Covering Project Related Support & Setup
      </>,
      'Exclusive Access to ATC’s SPC Community',
      'Monthly Q&A Sessions with SPCs'
    ],
  };

  const benefitsForScrum = {
    title: 'ATC Training - Exclusive Benefits',
    list: [
      'Training Conducted by Experts from the industry',
      <>
        <b>1 Year Membership</b> Covering Project Related Support & Setup
      </>,
      'Exclusive Access to ATC’s Scrum Community'
    ],
  };

  const benefitsForPmp = {
    title: 'ATC Training - Exclusive Benefits',
    list: [
      'Training Conducted by PMP Transformation Experts',
      <>
        <b>1 Year Membership</b> Covering Project Related Support & Setup
      </>,
      ' Access to Q&A sessions with Industry experts',
      'Highly interactive virtual sessions using whiteboards, polls, chat, breakout groups, and fun team-based contests.'
    ],
  }

  const whatYouGetDetails = [
    {
      type: 'png',
      icon: 'icons/wheel.png',
      title: 'Attendee Workbook',
      description: (
        <>
          Workbook to keep for
          <br />
          notes and examples
        </>
      ),
    },
    {
      type: 'svg',
      icon: SettingsIcon,
      title: 'Eligibility for SAFe Agilist Exam',
      description: (
        <>
          Preparation for SAFe Agilist Exam and
          <br />
          eligibility after course attendance
        </>
      ),
    },
    {
      type: 'svg',
      icon: SettingsIcon,
      title: '1 year SAFe Membership',
      description: (
        <>
          One year of membership to the
          <br />
          SAFe Community Platform
        </>
      ),
    },
    {
      type: 'svg',
      icon: WavesIcon,
      title: 'Certificate of Course Completion',
      description: (
        <>
          Certification to keep showing
          <br />
          completion of course
        </>
      ),
    },
  ];

  const whatYouGetDetailsForScrum = [
    {
      type: 'png',
      icon: 'icons/wheel.png',
      title: 'Attendee Workbook',
      description: (
        <>
          Workbook to keep for
          <br />
          notes and examples
        </>
      ),
    },
    {
      type: 'svg',
      icon: SettingsIcon,
      title: 'Eligibility for Scrum Exam',
      description: (
        <>
          Preparation for Scrum Alliance Exam &
          <br />
          eligibility after course attendance
        </>
      ),
    },
    {
      type: 'svg',
      icon: SettingsIcon,
      title: '2 years Membership',
      description: (
        <>
          Two years of membership to the
          <br />
          Scrum Alliance Community
        </>
      ),
    },
    {
      type: 'svg',
      icon: WavesIcon,
      title: 'Certificate of Course Completion',
      description: (
        <>
          Certification to keep showing
          <br />
          completion of course
        </>
      ),
    },
  ];
  const whatYouGetDetailsForPmp = [
    {
      type: 'png',
      icon: 'icons/wheel.png',
      title: 'Attendee Workbook',
      description: (
        <>
          Workbook to keep for
          <br />
          notes and examples
        </>
      ),
    },
    {
      type: 'svg',
      icon: SettingsIcon,
      title: 'Eligibility for PMP Exam',
      description: (
        <>
          Preparation for PMP Exam &
          <br />
          eligibility after course attendance
        </>
      ),
    },
    {
      type: 'svg',
      icon: SettingsIcon,
      title: '1 year PMP Membership',
      description: (
        <>
          One year of membership to the
          <br />
          PMP Community
        </>
      ),
    },
    {
      type: 'svg',
      icon: WavesIcon,
      title: 'Certificate of Course Completion',
      description: (
        <>
          Certification to keep showing
          <br />
          completion of course
        </>
      ),
    },
  ];


  const selectTraining = (training)=> {
    if(isScrumTraining){
      return {
        trainingName: "SCRUM",
        question: 'What does Certified Scrum Master Kit consists of?',
        benefits: benefitsForScrum,
        whatYouGetDetails: whatYouGetDetailsForScrum
      }
    }else if(isPmpTraining){
      return {
        trainingName: "PMP",
        question: 'What does the PMP certification kit consists of?',
        benefits: benefitsForPmp,
        whatYouGetDetails: whatYouGetDetailsForPmp
      }
    }else{
      return {
        trainingName: "SAFE",
        question: 'What does the SAFe Certification Kit consists of?',
        benefits: benefits,
        whatYouGetDetails: whatYouGetDetails
      }
    }

  }
  let trainingType = selectTraining(training)
  const faqList = [
    {
      question: 'What is the annual renewal fee?',
      answer: escapeToHTML(training.annualRenewal),
    },
    {
      question: 'What is the cancellation policy on this?',
      answer: (
        <>
          <p>
            In order to provide the most experienced instructors and a superior
            classroom environment, we must ask you to adhere to our cancellation
            policy. If it is necessary to cancel or reschedule this
            registration, please notify us immediately. Our cancellation policy
            is as follows:
          </p>
          <ul>
            <li>
              A full refund can be claimed 30 days prior to the class start
              date.
            </li>
            <li>
              No refund will be allowed within 30 days from the class start
              date, however students may reschedule to another class within one
              year of the cancellation date.
            </li>
            <li>
              No reschedules allowed within 7 business days unless its an
              unforeseen circumstances.
            </li>
            <li>
              In the event any cancellation occurred due to low enrollment or
              unforeseen natural events, ATC will issue a 100% refund.
            </li>
          </ul>
        </>
      ),
    },
    {
      question: trainingType.question,
      answer: escapeToHTML(training.certificationKit),
    },
  ];

  (trainingType.trainingName === "SCRUM" || trainingType.trainingName === "SAFE") && faqList.push({
    question:
      'What about Professional Development Units (PDUs) and Scrum educational units?',
    answer: (
      <>
        <p>{training.PDU}</p>
      </>
    ),
  },)


  return (
    <>
      <Meta
        title={`${training.certificationName} | ATC Training` || 'ATC Training'}
      />
      <Layout lightTheme path={path}>
        <TrainingDetailHero training={training}></TrainingDetailHero>
        <TrainingDetailContainer>
          <section>
            <div className="training-schedule-main">
              <div className="container">
                <SummaryAndBio training={training} showBio></SummaryAndBio>
                <ThreeColumnRedTiles
                  columnData={threeColumnRedTileData}
                ></ThreeColumnRedTiles>
              </div>
            </div>
          </section>
          <TwoColumnRedAndBlackTile
            columnData={twoColumRedAndBlackTileData}
          ></TwoColumnRedAndBlackTile>
          <PricingDetails
            training={training}
            benefits={trainingType.benefits}
            whatYouGetDetails={trainingType.whatYouGetDetails}
            isStrikeThrough
          ></PricingDetails>
          <FAQSection faqList={faqList}></FAQSection>
        </TrainingDetailContainer>
        <SectionContact
          title="View other available trainings."
          cta="Learn more"
          to="/trainings/"
        />
      </Layout>
    </>
  );
};

SafeTraining.propTypes = {
  training: PropTypes.object,
  path: PropTypes.string,
};

export default SafeTraining;
